import { 
  PRESUPUESTADOR_SELECT_BUSINESS_UNIT
} from './constants'

export function selectBusinessUnit(businessUnit) {
  return (dispatch, getState) => {
    if(businessUnit) {
      dispatch({
        type: PRESUPUESTADOR_SELECT_BUSINESS_UNIT,
        data: businessUnit
      })
    }
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_SELECT_BUSINESS_UNIT) {
      return {
        ...state,
       selectedBusinessUnit: action.data,
      }
  }
  else {
      return state
  }
}
